<template>
    <div class="ImageEnlarge">
        <!-- 统一模态框结构 -->
        <div id="modal" class="modal" ref="modal">
            <!-- 图片区域 -->
            <div class="modal-content" ref="imgWrapper">
                <img class="modal-img" id="modalImage" :src="src" ref="modalImage">
            </div>
            
            <!-- 顶部操作栏 -->
            <div class="toolbar">
                <span class="toolbar-btn" ref="rotateLeft" title="向左旋转">
                    <span class="iconfont">&#8634;</span>
                    <span class="text">左转</span>
                </span>
                <span class="toolbar-btn" ref="reset" title="重置">
                    <span class="iconfont">&#8634;</span>
                    <span class="text">重置</span>
                </span>
                <span class="toolbar-btn" ref="rotateRight" title="向右旋转">
                    <span class="iconfont">&#8635;</span>
                    <span class="text">右转</span>
                </span>
                <span class="toolbar-btn close-btn" ref="close" title="关闭">
                    <span class="iconfont">&times;</span>
                    <span class="text">关闭</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'ImageEnlarge',
    data() {
        return {
            scale: 1,
            rotation: 0,
            translateX: 0,
            translateY: 0,
            
            // 触摸/拖拽状态
            startX: 0,
            startY: 0,
            startTranslateX: 0,
            startTranslateY: 0,
            initialDistance: 0,
            isDragging: false,

            // 方法引用
            handleClose: () => { },
            handleRotateLeft: () => {},
            handleRotateRight: () => {},
            handleReset: () => {},
            handleMouseDown: () => {},
            handleMouseMove: () => {},
            handleMouseUp: () => {},
            handleTouchStart: () => {},
            handleTouchMove: () => {},
            handleTouchEnd: () => {},
            handleWheel: () => {}
        }
    },
    computed: {
        ...mapState(["isMobile"])
    },
    props: ["src"],
    mounted() {
        this.initMethods();
        
        // 1. 绑定按钮事件
        this.$refs.close.addEventListener("click", this.handleClose);
        this.$refs.rotateLeft.addEventListener("click", this.handleRotateLeft);
        this.$refs.rotateRight.addEventListener("click", this.handleRotateRight);
        this.$refs.reset.addEventListener("click", this.handleReset);
        
        // 2. 绑定图片交互事件
        const img = this.$refs.modalImage;
        
        // PC端：鼠标拖拽
        img.addEventListener('mousedown', this.handleMouseDown);
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mouseup', this.handleMouseUp);
        
        // 移动端：触摸拖拽/缩放
        img.addEventListener('touchstart', this.handleTouchStart, { passive: false });
        img.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        img.addEventListener('touchend', this.handleTouchEnd);
        
        // 通用：滚轮缩放
        img.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    beforeDestroy() {
        // 移除按钮监听
        if(this.$refs.close) this.$refs.close.removeEventListener("click", this.handleClose);
        if(this.$refs.rotateLeft) this.$refs.rotateLeft.removeEventListener("click", this.handleRotateLeft);
        if(this.$refs.rotateRight) this.$refs.rotateRight.removeEventListener("click", this.handleRotateRight);
        if(this.$refs.reset) this.$refs.reset.removeEventListener("click", this.handleReset);

        // 移除图片监听
        const img = this.$refs.modalImage;
        if(img) {
            img.removeEventListener('mousedown', this.handleMouseDown);
            img.removeEventListener('touchstart', this.handleTouchStart);
            img.removeEventListener('touchmove', this.handleTouchMove);
            img.removeEventListener('touchend', this.handleTouchEnd);
            img.removeEventListener('wheel', this.handleWheel);
        }
        
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('mouseup', this.handleMouseUp);
    },
    methods: {
        getDistance(p1, p2) {
            const dx = p1.clientX - p2.clientX;
            const dy = p1.clientY - p2.clientY;
            return Math.sqrt(dx * dx + dy * dy);
        },
        
        updateTransform() {
            if (this.$refs.modalImage) {
                this.$refs.modalImage.style.transform = 
                    `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale}) rotate(${this.rotation}deg)`;
            }
        },
        
        resetImageTransform() {
            this.scale = 1;
            this.rotation = 0;
            this.translateX = 0;
            this.translateY = 0;
            if (this.$refs.modalImage) {
                this.$refs.modalImage.style.transform = '';
            }
        },

        initMethods() {
            this.handleClose = () => {
                this.$emit("handleModal");
            };
            
            this.handleRotateLeft = (e) => {
                e.stopPropagation();
                this.rotation -= 90;
                this.updateTransform();
            };
            
            this.handleRotateRight = (e) => {
                e.stopPropagation();
                this.rotation += 90;
                this.updateTransform();
            };

            this.handleReset = (e) => {
                e.stopPropagation();
                this.resetImageTransform();
            };

            // --- PC端拖拽逻辑 ---
            this.handleMouseDown = (e) => {
                e.preventDefault();
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                this.startTranslateX = this.translateX;
                this.startTranslateY = this.translateY;
                this.$refs.modalImage.style.cursor = 'grabbing';
            };

            this.handleMouseMove = (e) => {
                if (!this.isDragging) return;
                const deltaX = e.clientX - this.startX;
                const deltaY = e.clientY - this.startY;
                this.translateX = this.startTranslateX + deltaX;
                this.translateY = this.startTranslateY + deltaY;
                this.updateTransform();
            };

            this.handleMouseUp = () => {
                if(!this.isDragging) return;
                this.isDragging = false;
                if(this.$refs.modalImage) {
                    this.$refs.modalImage.style.cursor = 'grab';
                }
            };

            // --- 移动端触摸逻辑 ---
            this.handleTouchStart = (e) => {
                if (e.touches.length === 1) {
                    e.preventDefault(); 
                    this.startX = e.touches[0].clientX;
                    this.startY = e.touches[0].clientY;
                    this.startTranslateX = this.translateX;
                    this.startTranslateY = this.translateY;
                } else if (e.touches.length === 2) {
                    this.initialDistance = this.getDistance(e.touches[0], e.touches[1]);
                }
            };

            this.handleTouchMove = (e) => {
                e.preventDefault(); 
                if (e.touches.length === 1) {
                    const currentX = e.touches[0].clientX;
                    const currentY = e.touches[0].clientY;
                    this.translateX = this.startTranslateX + (currentX - this.startX);
                    this.translateY = this.startTranslateY + (currentY - this.startY);
                    this.updateTransform();
                } else if (e.touches.length === 2) {
                    const currentDistance = this.getDistance(e.touches[0], e.touches[1]);
                    if (this.initialDistance > 0) {
                        const delta = (currentDistance - this.initialDistance) * 0.005;
                        this.initialDistance = currentDistance; 
                        this.scale = Math.max(0.5, Math.min(this.scale + delta, 5));
                        this.updateTransform();
                    }
                }
            };

            this.handleTouchEnd = () => {
                this.initialDistance = 0;
            };

            // --- 滚轮缩放逻辑 ---
            this.handleWheel = (e) => {
                e.preventDefault();
                const delta = e.deltaY > 0 ? -0.1 : 0.1;
                this.scale = Math.max(0.5, Math.min(this.scale + delta, 5));
                this.updateTransform();
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.ImageEnlarge {
    .modal {
        position: fixed;
        z-index: 100000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        
        /* 核心保留：背景透明且允许穿透 */
        background-color: transparent; 
        pointer-events: none; 

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .modal-content {
        /* 核心保留：内容层允许穿透 */
        pointer-events: none; 
        
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        
        img {
            /* 核心保留：图片可交互 */
            pointer-events: auto; 
            
            max-width: 90vw; 
            max-height: 85vh; 
            width: auto;
            height: auto;
            object-fit: contain;
            
            cursor: grab;
            user-select: none;
            touch-action: none;
            transform-origin: center center;
            transition: transform 0.05s linear;

            /* 保留阴影效果 */
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.6);
            border-radius: 4px;
        }
    }

    .toolbar {
        /* 核心保留：工具栏可交互 */
        pointer-events: auto; 
        
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100002;
        
        width: 100%;
        height: 50px; /* 修改：高度调小到 50px */
        
        /* 顶部安全区域适配 */
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        
        background: rgba(255, 255, 255, 0.2); 
        backdrop-filter: blur(10px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .toolbar-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            /* 修改：使用深蓝紫色 */
            color: #4338ca; 
            
            padding: 4px 15px; /* 稍微减小内边距 */
            cursor: pointer;
            transition: all 0.2s;

            &:active {
                opacity: 0.6;
                transform: scale(0.95);
            }

            .iconfont {
                font-size: 20px; /* 图标稍微缩小一点 */
                font-weight: bold;
                line-height: 1;
                margin-bottom: 2px;
                font-family: sans-serif;
            }
            
            .text {
                font-size: 10px;
                opacity: 0.9;
            }
        }

        /* 关闭按钮保持红色，避免混淆 */
        .close-btn {
            color: #ff4d4f;
            .iconfont {
                font-size: 24px;
            }
        }
    }
}

/* 移动端适配 */
@media (max-width: 1024px) {
    .ImageEnlarge {
        .modal-content img {
            max-width: 100vw;
            max-height: 100vh;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
        }
        .toolbar {
            height: 50px; /* 移动端也保持 50px */
            background: rgba(255, 255, 255, 0.15);
            color: #fff; 
            border-bottom: none; // 移动端透明度高，去掉边框
            
            .toolbar-btn {
                color: #4338ca; /* 移动端也强制使用深蓝紫色，保证可读性 */
                // 如果背景较暗，可以适当调亮颜色，例如：
                // color: #6366f1; 
            }
            .close-btn {
                color: #ff4d4f;
                    .iconfont {
                    font-size: 24px;
                }
            }
        }
    }
}
</style>
